import { arSA, enUS } from "date-fns/locale";
import { useTranslation } from "react-i18next";
import { formatDistanceToNow } from "date-fns";

import {
  getAgentProfileRoute,
  getCoachProfileRoute,
  getEntityProfileRoute,
  getOtherProfileRoute,
  getPlayerProfileRoute,
  getScoutProfileRoute,
} from "../../../routers/routeUtils";
import { formatMediaUrl } from "../../../utils/formatters/formatMedia";

import { Post } from "../types/types";
import { useUserDataFormatter } from "../../User/hooks/useUserDataFormatter";

export const usePostFormatter = (post: Post) => {
  const { t, i18n } = useTranslation("common");
  const currentLang = i18n.language;
  const selectedLocale = currentLang === "ar" ? arSA : enUS;

  const timeAgo = formatDistanceToNow(new Date(Number(post.createdAt)), {
    addSuffix: true,
    locale: selectedLocale,
  });

  const { author, media, challenge } = post;
  const authorLink = author.entity
    ? getEntityProfileRoute(author.entity.id)
    : author.role === "PLAYER"
    ? getPlayerProfileRoute(author?.id || "")
    : author.role === "AGENT"
    ? getAgentProfileRoute(author?.id || "")
    : author.role === "SCOUT"
    ? getScoutProfileRoute(author?.id || "")
    : author.role === "COACH"
    ? getCoachProfileRoute(author?.id || "")
    : getOtherProfileRoute(author?.id || "");

  const postMedia = media?.map((media) => ({
    ...media,
    url: formatMediaUrl(media.url),
    thumbnail: media.thumbnail ? formatMediaUrl(media.thumbnail) : "https://placehold.co/521",
  }));

  const {
    fullName: winnerName,
    firstTwoChr: winnerFirstTwoChr,
    media: winnerMedia,
    profileLink: winnerProfileLink,
  } = useUserDataFormatter(challenge?.winner ?? undefined);

  return {
    ...post,
    authorFullName: `${author.firstName} ${author.lastName}`.trim(),
    authorMedia: formatMediaUrl(author?.media?.url || author?.entity?.mediaUrl),
    authorFirstTwoChr: `${author.firstName?.slice(0, 1).toUpperCase()}${author.lastName?.slice(0, 1).toUpperCase()}`,
    authorRole: author.role ? t(`user.role.${author.role}`) : t(`user.role.${author.subRole}`),
    authorId: author.id,
    postMedia,
    authorLink,
    timeAgo,
    winner: {
      avatar: winnerMedia,
      firstTwoChr: winnerFirstTwoChr,
      name: winnerName,
      profileLink: winnerProfileLink,
    },
  };
};
